import { useMutation, useQueryClient } from '@tanstack/react-query'

import { connectInvoicing } from '@flecto/api/shared'
import { type CoreConnectInvoicing } from '@flecto/types'

type MutationPayload = {
  payload: CoreConnectInvoicing
}

export function useMutationConnectInvoicing() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['MutationConnectInvoicing'],
    mutationFn: async ({ payload }: MutationPayload) => {
      await connectInvoicing({ payload })
    },
    onSuccess: () =>
      queryClient.invalidateQueries(['QueryGetInvoicingProvider']),
  })
}
